import React from 'react'

import Footer from '../Utils/Footer';
import Header from '../Utils/Header';


export default function Alumni() {
  return (
      <div>
          <Header heading="Alumni" />
          
          <Footer />
          {/* <button onClick={() => {

        auth.Logout_frontend();
        navigate("/");

      }}>Logout</button> */}

      </div>
  )
}
